<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="600px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wybierz etykiety do ponownego wydruku
                </h1>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-data-table
                            v-model="shipmentsSelectedToPrint"
                            :headers="shipmentsHeaders"
                            :items="shipments"
                            item-key="id"
                            show-select
                            hide-default-footer
                            disable-pagination
                            :mobile-breakpoint="0"
                            name="shipmentsData"
                        >
                            <template #item.carrierName="{item}">
                                {{ item.carrier.name }}
                            </template>
                            <template #item.createdAt="{item}">
                                {{ formatDate(item.createdAt) }}
                            </template>
                            <template #item.shippedAmount="{item}">
                                {{ item.shippedAmount }}
                            </template>
                            <template #item.numberOfLabels="{item}">
                                {{ item.numberOfLabels }}
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </div>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Wydrukuj"
                    @click="reprintLabels"
                >
                    Wydrukuj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'ReprintPackageLabelsDialog',
    mixins: [
        dateFormatter
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        parcelData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            shipmentsSelectedToPrint: [],
            shipmentsHeaders: [
                {
                    text: 'Kurier',
                    align: 'center',
                    sortable: false,
                    value: 'carrierName'
                },
                {
                    text: 'Data utworzenia',
                    align: 'left',
                    sortable: false,
                    value: 'createdAt'
                },
                {
                    text: 'Nadany nakład',
                    align: 'center',
                    sortable: false,
                    value: 'shippedAmount'
                },
                {
                    text: 'Ilość etykiet',
                    align: 'center',
                    sortable: false,
                    value: 'numberOfLabels'
                },
            ]
        }
    },
    computed: {
        shipments() {
            return this.parcelData.shipments
        }
    },
    methods: {
        reprintLabels() {
            const shipmentsIds = this.shipmentsSelectedToPrint.map(item => item.id)

            this.$emit('reprint-package-labels', shipmentsIds)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.shipmentsSelectedToPrint = []
            }, 500)
            this.$emit('on-close')
        }
    }
}
</script>